/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import axios from "axios";
import { is_breakpoint_up, make_url, scroll_to } from "../helpers/functions";
import App from "../helpers/app";

$(function () {
  function initLeadStickyEvent() {
    let $widget = $(".lead-aside");
    if (!$widget.length) {
      return;
    }

    let $parent = $widget.closest(".lead-container");
    let $stickContainer = $widget;
    let $isInitialized =
      $stickContainer.data("sticky_kit") == true ? true : false;

    if ($isInitialized) {
      $stickContainer.trigger("sticky_kit:detach");
    }

    if (is_breakpoint_up("lg")) {
      $stickContainer.stick_in_parent({
        offset_top:
          125 +
          ($(".header-spacer").length ? $(".header-spacer").outerHeight() : 0),
        parent: $parent,
      });
    }
  }

  function initLeadActionEvent() {
    let $widget = $(".lead-aside");
    if (!$widget.length) {
      return;
    }

    let $element = $widget.find(".lead-contact-action");
    let $className = "scrolled-below";

    if (
      $(window).scrollTop() <
      $widget.find(".form-content").offset().top - $(window).height()
    ) {
      if ($element.hasClass($className)) {
        $element.removeClass($className);
      }
    } else {
      if (!$element.hasClass($className)) {
        $element.addClass($className);
      }
    }
  }

  function initLeadEvents() {
    let $widget = $(".lead-aside, .lead-quick");
    if (!$widget.length) {
      return;
    }

    let $isCompanyField = $widget.find('[name*="[is_company]"]');
    let $nipField = $widget.find('[name*="[nip_nr]"]');
    let $brandField = $widget.find('[name*="[brand]"]');
    let $modelField = $widget.find('[name*="[model]"]');

    if ($isCompanyField.length) {
      $isCompanyField
        .change(function () {
          if (!$isCompanyField.closest(".form-group").is(":visible")) {
            $nipField.closest(".form-group").show();
          } else {
            $nipField.closest(".form-group").hide();

            if ($isCompanyField.is(":checked")) {
              $nipField.closest(".form-group").show();
            }
          }
        })
        .change();
    }

    if ($brandField.length && $modelField.length) {
      $brandField
        .change(function () {
          let $modelsData = $modelField.data("models");
          $modelField.empty().attr("disabled");
          $modelField.append("<option value>Wybierz model</option>");
          if (typeof $modelsData[$brandField.val()] !== "undefined") {
            $modelField.removeAttr("disabled");
            $.each($modelsData[$brandField.val()], function (k, v) {
              $modelField.append(
                '<option value="' + k + '">' + v + "</option>",
              );
            });
          }
        })
        .change();

      $modelField.change(function () {
        dataLayer = window.dataLayer || [];
        dataLayer.push({
          carBrand: $brandField
            .find('option[value="' + $brandField.val() + '"]')
            .text(),
          carType: $modelField
            .find('option[value="' + $modelField.val() + '"]')
            .text(),
        });
      });
    }

    let $form = $widget.find("form");

    $form.submit(function (e) {
      e.preventDefault();

      let data = $(this).data("yiiActiveForm");
      if (data && typeof data.validated !== "undefined" && !data.validated) {
        return false;
      }

      let $buttonLoader = $form.find('[type="submit"]');
      App.loader.init($buttonLoader, "button");

      axios
        .post(
          $form.attr("action")
            ? $form.attr("action")
            : make_url("/carsell/utils/quick-lead"),
          $form.serialize(),
          {
            params: {
              from: $.address.value(),
            },
          },
        )
        .then(function (response) {
          App.loader.end($buttonLoader);

          if (typeof response.data.errors !== "undefined") {
            $form.data("yiiActiveForm").attributes.forEach((attribute) => {
              if (typeof response.data.errors[attribute.name] !== "undefined") {
                $form.yiiActiveForm("updateAttribute", attribute.id, [
                  response.data.errors[attribute.name],
                ]);
              }
            });
          }

          if (
            typeof response.data.success === "undefined" ||
            !response.data.success
          ) {
            return;
          }

          $form.find(".step-form").slideUp();
          $form.find(".step-success").slideDown(function () {
            $form.trigger("submitted");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "formSend",
              form: $.address.value(),
              leadcm: response.data.lead_id ?? "",
              "lead.form.firstNameHash":
                typeof response.data.lead_id !== "undefined"
                  ? response.data.data.firstNameHash ?? ""
                  : "",
              "lead.form.emailHash":
                typeof response.data.lead_id !== "undefined"
                  ? response.data.data.emailHash ?? ""
                  : "",
              "lead.form.phoneHash":
                typeof response.data.lead_id !== "undefined"
                  ? response.data.data.phoneHash ?? ""
                  : "",
              "st.step": 2,
            });
          });

          if (typeof response.data.tracking !== "undefined") {
            $form
              .find(".step-success .tracking")
              .empty()
              .append(response.data.tracking);
          }
        });
    });

    $widget.find(".lead-contact-action").click(() => scroll_to($form));

    initLeadActionEvent();
    $(window).on("scroll", function () {
      initLeadActionEvent();
    });

    initLeadStickyEvent();
    $(window).on("resize headerSpacer.resized", function () {
      initLeadStickyEvent();
    });
  }

  initLeadEvents();
});
